export default __webpack_public_path__ + "static/media/ico-beian.0c577066.png";